module.exports = __webpack_public_path__ + "img/chatbot6.41e01950.svg";